(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["averi-lookbook"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('averi-lookbook-video')) {
  customElements.define('averi-lookbook-video', class extends HTMLElement {
    connectedCallback() {
      const video = this.querySelector('video');
      if (!video) return;
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      if (!('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.1) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      }, { threshold: [0, 0.1] });
      this.observer.observe(video);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.querySelector('video')?.pause();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["averi-password-background"]) return;
  try {
    
  if (!customElements.get('averi-password-slideshow')) {
    customElements.define('averi-password-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.averi-password-slide')];
        this.index = 0;
        this.interval = Math.max(5000, Number(this.dataset.interval) || 10000);
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.abort = new AbortController();
        this.slides.forEach((slide, index) => slide.classList.toggle('is-active', index === 0));
        this.onStateChange = () => {
          clearTimeout(this.timer);
          if (!document.hidden && !this.motion.matches && this.slides.length > 1) this.schedule();
        };
        document.addEventListener('visibilitychange', this.onStateChange, { signal: this.abort.signal });
        this.motion.addEventListener('change', this.onStateChange, { signal: this.abort.signal });
        this.onStateChange();
      }
      schedule() {
        const next = this.slides[(this.index + 1) % this.slides.length].querySelector('img');
        if (next) next.loading = 'eager';
        this.timer = setTimeout(() => this.advance(), this.interval);
      }
      async advance() {
        const nextIndex = (this.index + 1) % this.slides.length;
        const image = this.slides[nextIndex].querySelector('img');
        try {
          if (image) await image.decode();
        } catch {
          if (this.isConnected && !this.abort.signal.aborted && !document.hidden && !this.motion.matches) this.schedule();
          return;
        }
        if (!this.isConnected || this.abort.signal.aborted || document.hidden || this.motion.matches) return;
        const previous = this.slides[this.index];
        const next = this.slides[nextIndex];
        next.classList.add('is-entering');
        this.index = nextIndex;
        const duration = parseFloat(getComputedStyle(this).getPropertyValue('--averi-fade')) * 1000 || 2000;
        this.finishTimer = setTimeout(() => {
          next.classList.add('is-active');
          next.classList.remove('is-entering');
          previous.classList.remove('is-active');
        }, duration);
        this.schedule();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        clearTimeout(this.finishTimer);
        this.abort?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
